// btw-front/src/api/adminPerformance.js
import { api } from "./client";

// 인자 없으면: 파트너별 집계 + 글로벌 KPI ({kpi, partners})
// partnerId 주면: 특정 파트너 실적 (partner endpoint 와 동일 응답 — {kpi, byQuarter, topCustomers, recentActivity})
export async function get(partnerId) {
  const qs = partnerId ? `?partnerId=${encodeURIComponent(partnerId)}` : "";
  return api.get(`/admin/performance${qs}`);
}
